import { useContext } from 'react';
import { ApiProvider } from '../context';

export default function useApi() {
    const api = useContext(ApiProvider.Context);

    if (!api) {
        throw new Error('Api was not initialised.');
    }

    return api;
}
